import { render, staticRenderFns } from "./ln-form-checkbox-nested.vue?vue&type=template&id=bfc39738&"
import script from "./ln-form-checkbox-nested.vue?vue&type=script&lang=js&"
export * from "./ln-form-checkbox-nested.vue?vue&type=script&lang=js&"
import style0 from "./ln-form-checkbox-nested.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconChevron: require('/usr/src/app/components/icons/icon-chevron.vue').default,LnField: require('/usr/src/app/components/ln-form/ln-field.vue').default})
